export default "__VITE_ASSET__BnHJv3xn__"